module.exports = __webpack_public_path__ + "assets/img/index-intro-xs-01@2x.d2b171f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/index-intro-xs-01@2x.png
// module id = 902
// module chunks = 1